module.exports = __webpack_public_path__ + "img/logo.26564c1e.png";